import { createTheme, responsiveFontSizes } from "@mui/material";
import React from "react";

let AppTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: "none",
          fontWeight: 600,
          padding: "12px 24px",
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(99, 102, 241, 0.4)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: "0 4px 24px rgba(0, 0, 0, 0.08)",
        },
      },
    },
  },
  typography: {
    fontFamily: '"Inter", "Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h1: {
      fontSize: 56,
      lineHeight: 1.1,
      fontWeight: 700,
      color: "#0F172A",
      letterSpacing: "-0.02em",
    },
    h2: {
      fontSize: 40,
      lineHeight: 1.2,
      fontWeight: 700,
      color: "#0F172A",
      letterSpacing: "-0.01em",
    },
    h3: {
      fontSize: 28,
      lineHeight: 1.3,
      fontWeight: 600,
      color: "#0F172A",
    },
    h4: {
      fontSize: 22,
      lineHeight: 1.4,
      fontWeight: 600,
      color: "#0F172A",
    },
    h5: {
      fontSize: 18,
      lineHeight: 1.5,
      fontWeight: 600,
      color: "#0F172A",
    },
    h6: {
      fontSize: 16,
      lineHeight: 1.5,
      fontWeight: 500,
      color: "#0F172A",
    },
    subtitle: {
      fontSize: 18,
      lineHeight: 1.6,
      fontWeight: 400,
      color: "#64748B",
    },
    subtitle2: {
      fontSize: 14,
      lineHeight: 1.5,
      fontWeight: 400,
      color: "#64748B",
    },
    body1: {
      fontSize: 16,
      lineHeight: 1.6,
      color: "#475569",
    },
    body2: {
      fontSize: 14,
      lineHeight: 1.6,
      color: "#64748B",
    },
    button: {
      fontSize: 15,
      lineHeight: 1.4,
      fontWeight: 600,
      color: "#0F172A",
      textTransform: "none",
    },
  },
  palette: {
    primary: {
      main: "#6366F1",
      light: "#818CF8",
      dark: "#4F46E5",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#10B981",
      light: "#34D399",
      dark: "#059669",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#FFFFFF",
      paper: "#F8FAFC",
    },
    error: {
      main: "#EF4444",
      light: "#F87171",
    },
    warning: {
      main: "#F59E0B",
      light: "#FBBF24",
    },
    text: {
      primary: "#0F172A",
      secondary: "#64748B",
    },
  },
});

AppTheme = responsiveFontSizes(AppTheme)

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    hyperlink: true;
    overline: false;
    body: true;
    body1: false;
    subtitle: true;
    subtitle1: false;
  }
}

declare module "@mui/material/styles" {
  interface TypographyVariants {
    hyperlink: React.CSSProperties;
    body: React.CSSProperties;
    subtitle: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    hyperlink?: React.CSSProperties;
    body?: React.CSSProperties;
    subtitle?: React.CSSProperties;
  }
}

export default AppTheme;
